// Generate per tab — persists only for current tab session
export const TAB_ID = sessionStorage.getItem('tab-id') || (() => {
	const id = crypto.randomUUID?.() || Math.random().toString(36).substring(2, 10);
	sessionStorage.setItem('tab-id', id);
	return id;
})();
